// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "工程力学",
      "tec": "陈丽华",
      "week": "1-12周",
      "add": "教学楼C座309教务"
    },
    {
      "sub": "科技应用文写作与沟通艺术",
      "tec": "李宏波",
      "week": "1-15,18周",
      "add": "教学楼C座212教务"
    },
    {
      "sub": "工程热力学",
      "tec": "卫运钢",
      "week": "1-12周",
      "add": "教学楼C座310教务"
    },
    {
      "sub": "马克思主义基本原理",
      "tec": "王爱华",
      "week": "1-12周",
      "add": "教学楼A座325电力"
    },
    {
      "sub": "形势与政策",
      "tec": "张文东",
      "week": "1-4周",
      "add": "教学楼C座210教务"
    }
  ],
  "2": [
    [
      {
        "sub": "大学英语（三）",
        "tec": "金品卓",
        "week": "1-14周",
        "add": "实训楼E座310"
      },
      {
        "sub": "25动核新1-2",
        "tec": "张育智",
        "week": "1-14周",
        "add": "实训楼Ｅ座501语音室"
      },
      {
        "sub": "25动核新2-1",
        "tec": "刘雅玲",
        "week": "1-14周",
        "add": "实训楼E座418法律"
      },
      {
        "sub": "25动核新2-3",
        "tec": "孟庆双",
        "week": "1-14周",
        "add": "实训楼E座414管理"
      },
      {
        "sub": "25动核新2-2",
        "tec": "杜薇",
        "week": "1-14周",
        "add": "教学楼B座121自控"
      },
      {
        "sub": "25动核新2-4",
        "tec": "贺静",
        "week": "1-14周",
        "add": "教学楼D座125经管"
      },
      {
        "sub": "25动核新1-1",
        "tec": "刘妍",
        "week": "1-14周",
        "add": "教学楼B座319能动"
      },
      {
        "sub": "25动核新1-4",
        "tec": "冯冬惠",
        "week": "1-14周",
        "add": "教学楼B座220能动"
      }
    ],
    {
      "sub": "大学物理（下)",
      "tec": "江翠",
      "week": "1-14周",
      "add": "教学楼A座221电力"
    },
    {
      "sub": "工程制图",
      "tec": "张贺",
      "week": "5-15,18周",
      "add": "教学楼C座309教务"
    },
    0,
    {
      "sub": "普通化学",
      "tec": "马珊珊",
      "week": "1-8周",
      "add": "教学楼B座325能动"
    }
  ],
  "3": [
    {
      "sub": "概率论与数理统计",
      "tec": "刘永楠",
      "week": "1-15,18周",
      "add": "教学楼A座425机械"
    },
    [
      {
        "sub": "体育（三）",
        "tec": "张慧",
        "week": "1-18周",
        "add": "轮滑"
      },
      {
        "sub": "健美操",
        "tec": "姚宝剑",
        "week": "1-18周",
        "add": "轮滑"
      },
      {
        "sub": "男篮",
        "tec": "李欣诺",
        "week": "1-18周",
        "add": "轮滑"
      },
      {
        "sub": "男网",
        "tec": "李罡",
        "week": "1-18周",
        "add": "轮滑"
      },
      {
        "sub": "足球",
        "tec": "刘玉坤",
        "week": "1-18周",
        "add": "轮滑"
      },
      {
        "sub": "搏击",
        "tec": "李莉",
        "week": "1-18周",
        "add": "轮滑"
      },
      {
        "sub": "女篮",
        "tec": "郝俊",
        "week": "1-18周",
        "add": "轮滑"
      },
      {
        "sub": "女排",
        "tec": "高佳",
        "week": "1-18周",
        "add": "轮滑"
      },
      {
        "sub": "男乒",
        "tec": "李灏",
        "week": "1-18周",
        "add": "轮滑"
      },
      {
        "sub": "男乒",
        "tec": "郭芯源",
        "week": "1-18周",
        "add": "轮滑"
      },
      {
        "sub": "男篮",
        "tec": "王文娇",
        "week": "1-18周",
        "add": "轮滑"
      },
      {
        "sub": "男羽",
        "tec": "王莹莹",
        "week": "1-18周",
        "add": "轮滑"
      },
      {
        "sub": "女网",
        "tec": "任德鑫",
        "week": "1-18周",
        "add": "轮滑"
      },
      {
        "sub": "足球",
        "tec": "李庆",
        "week": "1-18周",
        "add": "轮滑"
      }
    ],
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "工程制图",
      "tec": "张贺",
      "week": "5-15,18周",
      "add": "教学楼C座310教务"
    },
    {
      "sub": "马克思主义基本原理",
      "tec": "王爱华",
      "week": "1-12周",
      "add": "教学楼A座325电力"
    },
    {
      "sub": "工程热力学",
      "tec": "卫运钢",
      "week": "1-12周",
      "add": "教学楼C座309教务"
    },
    {
      "sub": "工程力学",
      "tec": "陈丽华",
      "week": "1-12周",
      "add": "教学楼C座309教务"
    },
    {
      "sub": "就业创业指导",
      "tec": "谢天瑶",
      "week": "5-9周",
      "add": "教学楼B座220能动"
    }
  ],
  "5": [
    {
      "sub": "大学物理（下)",
      "tec": "江翠",
      "week": "1-14周",
      "add": "教学楼A座221电力"
    },
    [
      {
        "sub": "能源电力工程英语（上）",
        "tec": "刘雅玲",
        "week": "1-14周",
        "add": "实训楼Ｅ座501语音室"
      },
      {
        "sub": "25动核新2-3",
        "tec": "杜薇",
        "week": "1-14周",
        "add": "实训楼E座414管理"
      },
      {
        "sub": "25动核新2-4",
        "tec": "孟庆双",
        "week": "1-14周",
        "add": "教学楼B座120自控"
      },
      {
        "sub": "25动核新2-2",
        "tec": "刘妍",
        "week": "1-14周",
        "add": "实训楼E座412语音室"
      },
      {
        "sub": "25动核新1-4",
        "tec": "冯冬惠",
        "week": "1-14周",
        "add": "实训楼E座406语音室"
      },
      {
        "sub": "25动核新1-3",
        "tec": "金品卓",
        "week": "1-14周",
        "add": "教学楼D座125经管"
      },
      {
        "sub": "25动核新1-2",
        "tec": "贺静",
        "week": "1-14周",
        "add": "实训楼E座310"
      },
      {
        "sub": "25动核新1-1",
        "tec": "张育智",
        "week": "1-14周",
        "add": "实训楼E座418法律"
      }
    ],
    {
      "sub": "概率论与数理统计",
      "tec": "刘永楠",
      "week": "1-15单周",
      "add": "教学楼A座421机械"
    },
    {
      "sub": "普通化学",
      "tec": "马珊珊",
      "week": "1-8周",
      "add": "教学楼B座325能动"
    },
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
